module.exports = __webpack_public_path__ + "media/images/icon-badge-new@3x-93134647575add9379a6801dbb79d295.png";